//#region Styles
import { Container } from "./styles";
//#endregion
//#region Images
import ArrowIcon from "icons/ArrowIcon";
//#endregion

const AccordionButton = ({
    isOpened, toggleIsOpened
}) => {
    return (
        <Container 
            className={isOpened && "opened"} 
            onClick={toggleIsOpened}>
            <ArrowIcon size={{ width: "18", height: "24" }}/>
        </Container>
    );
}

export default AccordionButton;